import React from 'react'
import i18n from 'live/services/i18n'
import moment from 'moment'
import DateService from 'live/services/date'
import FormGroup from 'live/components/forms/ui/form-group'

import DatePicker from 'react-datepicker'
import MaskedInput from 'react-maskedinput'
import CustomDateInput from 'live/components/forms/ui/custom-react-datepicker-input'
import { getUnixFromDateAndTime } from '../../../forms/annotation-default-form'

interface Props {
    value: number
    isTime: boolean
    onChange: (val?: number) => void
}

export default function PeriodPicker(props: Props): JSX.Element {
    const { isTime, onChange } = props

    return isTime ? (
        <DateTimePicker initialValue={props.value} handleChange={onChange} />
    ) : (
        <ValuePicker initialValue={props.value} handleChange={onChange} />
    )
}

function DateTimePicker(props: { initialValue: number; handleChange: (value?: number) => void }): JSX.Element {
    const [invalidDate, setInvalidDate] = React.useState(isNaN(props.initialValue))
    const begin = invalidDate ? null : moment(props.initialValue)
    const [date, setDate] = React.useState(begin)
    const [time, setTime] = React.useState(begin?.format?.('HH:mm:ss'))

    React.useEffect(() => {
        if (!date || !time) return props.handleChange()

        const value = getUnixFromDateAndTime(date, time)

        if (isNaN(value)) {
            props.handleChange()

            return setInvalidDate(true)
        }

        setInvalidDate(false)

        props.handleChange(value)
    }, [date, time])

    return (
        <div className="flex flex-space-between period-picker-time">
            <div className="flex-2 mr-5 date">
                <label>{i18n('Marker date')}</label>
                <DatePicker
                    id="timeline-from-date-picker"
                    customInput={<CustomDateInput invalid={invalidDate} />}
                    autoComplete="false"
                    selected={date}
                    onChange={m => setDate(m)}
                    maxDate={moment()}
                    dateFormat={DateService.getDateFormat()}
                    placeholderText={DateService.getDateFormat().toLowerCase()}
                    fixedHeight
                    peekNextMonth
                    showYearDropdown
                    showMonthDropdown
                />
            </div>
            <div className="flex-1 ml-5 time">
                <label>{i18n('Hour')}</label>

                <MaskedInput
                    className={invalidDate ? 'error' : ''}
                    type="text"
                    value={time}
                    onChange={evt => setTime(evt.target.value)}
                    mask="11:11:11"
                />
            </div>
        </div>
    )
}

function ValuePicker(props: { initialValue: number; handleChange: (value?: number) => void }): JSX.Element {
    const [value, setValue] = React.useState(props.initialValue)

    return (
        <div>
            <label style={{ textAlign: 'left', marginBottom: '5px' }}>{i18n('Begin')}</label>
            <FormGroup
                type="number"
                value={value}
                validationState={isNaN(value) ? 'error' : 'success'}
                onChange={e => {
                    setValue(e.target.value)
                    props.handleChange(isNaN(e.target.value) ? undefined : Number(e.target.value))
                }}
            />
        </div>
    )
}
